<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Members

          <a
            target="_blank"
            class="btn btn-default"
            @click="exportList"
          >
            <i
              class="fas fa-link"
              aria-hidden="true"
            />
          </a>
          <a
            class="btn btn-default"
            @click="refresh"
          >
            <i
              class="fas fa-sync-alt"
              aria-hidden="true"
            />
          </a>
        </h1>
      </div>
    </section>
    <section>
      <div class="tw-mx-2">
        <div class="tw-text-xs">
          <!-- <AdminSearchFilter /> -->
          <TableServer :options="options" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    // AdminSearchFilter: () => import('@/components/admin/AdminSearchFilter'),
    TableServer: () => import('@/components/_vue/TableServer'),
  },

  data() {
    return {
      options: {
        buttons: 'admin-actions',
        url: '/api/admin/members',
        name: 'members',
        columns: [
          'actions',
          'thumb',
          'id',
          'name',
          'email',
          'age',
          'gender',
          // 'incomplete',
          // 'geo',
          'currentlyIn',
          'backer',
          // 'registration_referer',
          'status',
          'createdAt',
          'lastSeenAt',

          'invitationsSent',
          'invitationsReceived',
          'matchesMade',
          'matchRatio',
          'travelPlansAdded',
          'messagesSent',
          'messagesReceived',
          'icebreakersSent',
          'icebreakersReceived',

          // 'backerId',
          // 'backerName',
          // 'backer_email',
          // 'backer_amount',
          // 'backer_perk',
        ],
        tableOptions: {
          perPage: 100,
          sortable: [
            'id',
            'name',
            'email',
            'createdAt',
            'lastSeenAt',
            'sent_requests_count',
            'received_requests_count',
            'matches_count',
            'messages_count',
            'travel_plans_count',
            // 'backerId',
            // 'backerName',
            // 'backer_email',
            // 'backer_amount',
            // 'backer_perk',
          ],
          headings: {
            // sent_requests_count: 'Sent',
            // received_requests_count: 'Received',
            // matches_count: 'Matches',
            // sent_to_match_ratio: 'Ratio',
            // messages_count: 'Messages',
            // travel_plans_count: 'Plans',

            createdAt: 'Signed Up',
            lastSeenAt: 'Last Seen',
            currentlyIn: 'Currently In',

            invitationsSent: 'Requests Sent',
            invitationsReceived: 'Requests Received',
            matchesMade: 'Matches',
            matchRatio: 'Ratio',
            travelPlansAdded: 'Plans',
            favorited: 'Favorited By',
            liked: 'Liked By',
            messagesSent: 'Messages Sent',
            messagesReceived: 'Messages Received',
            icebreakersSent: 'Icebreakers Sent',
            icebreakersReceived: 'Icebreakers Received',
          },
          orderBy: {
            column: 'createdAt',
            ascending: false,
          },
          filterable: ['name', 'email'],
          customFilters: ['admin-filters'],
        },
      },
    };
  },

  methods: {
    exportList() {
      const link = `/api/admin/members/export?token=${this.$auth.token()}`;
      window.open(link, '_blank');
    },

    refresh() {
      Bus.$emit('refresh');
    },
  },
};
</script>

<style>
.v-table tr,
.v-table td {
  @apply tw-whitespace-no-wrap tw-text-center tw-align-middle;
}

.VueTables__limit {
  display: none;
}
</style>
